<template>
<!--    check_config is false because we already check config in this component-->
<!--    <np-input v-bind="$attrs" ref="input" :check_config="false" :required="isRequired" :addon-class="addonClass"  @enter="validatePhone" @addon-click="validatePhone" :label="label" v-model="keyword" @input="val => $emit('input', formatPhone(val))" >-->
    <np-input v-bind="$attrs" :check_config="false" :required="isRequired" :disabled="disabled" :addon-class="addonClass"
              @enter="validatePhone" @addon-click="validatePhone"
              :label="label" v-model="keyword" @update:model-value="val => $emit('update:modelValue', val)" >
        <template v-slot:addon v-if="phone_valid_status === 3">
        <span ><i class="fa fa-check"> </i></span>
        </template>
        <template v-slot:addon v-else-if="phone_valid_status === 2">
        <span class="error" ><i class="fa fa-times"> </i></span>
        </template>
        <template v-slot:addon v-else-if="phone_valid_status === 1">
        <span ><i class="fa fa-spinner fa-spin"> </i></span>
        </template>
        <template v-slot:addon v-else-if="phone_valid_status === 0 && showValidateButton">
        <span >{{lang('validate')}}</span>
        </template>
    </np-input>
</template>
<script>
    import NPInput from './np-input.vue';
    import NpResponsive from "./np-responsive.vue";
    export default {
        name: 'np-phone',
        // props: ['label', 'value', 'phoneCode', 'showValidateButton', 'required', 'check_config'],
        props: {
            label: String,
            modelValue: [String, Number],
            phoneCode: String,
            showValidateButton: Boolean,
            reference: {
                default: false,
            },
            nonLeadingZero: Boolean,
            check_config: {
                default: true
            },
            disabled: {
                default: false
            },
            required: {
                default: true,
            },
        },
        components: {
            'np-input': NPInput,
        },
        data: function(){
            return {
                phone_valid_status: 0,
                keyword: '',
                addonClass: {},
                phone_cache: {},
                phone_status: {
                    reset: 0,
                    validating: 1,
                    error: 2,
                    success: 3,
                },
                page_config_required: false
            }
        },
        created: function (){
            // This component should word without v-model binding
            this.keyword = this.modelValue;
        },
        computed: {
            isRequired: function (){
                return !!this.check_config ? this.page_config_required : this.required
            }
        },
        methods: {
            formatPhone: function (phone){
               return phone.trim().charAt(0) === '0' ? phone.substring(1) : phone
            },
            validatePhone(phone) {
                const payload = {
                    country_calling_code: this.phoneCode.split('|')[1],
                    customer_phone: phone
                };
                // const configs = {
                //     headers: {'X-Requested-With': 'XMLHttpRequest'}
                // };

                if(this.phone_cache.hasOwnProperty(phone)) {
                    this.phone_valid_status = (this.phone_cache[phone]['valid'] === true) ? this.phone_status.success : this.phone_status.error;

                } else {
                    this.phone_valid_status = this.phone_status.validating;

                    this.getAxiosInstance().post('/externalservices/validatephone', payload)  //, configs)
                        .then(response => {
                            const data = response.data;
                            this.phone_cache[phone] = data;
                            this.phone_valid_status = data['valid'] ? this.phone_status.success : this.phone_status.error;
                        })
                        .catch(error => {
                            this.phone_valid_status = this.phone_status.error;
                        })
                }
            }
        },
        watch: {
            modelValue: function (val) {
                this.phone_valid_status = 0;
                this.keyword = val;
            },
            phoneCode: function (val) {
                this.phone_valid_status = 0;
            },
            phone_valid_status: function (val) {
                if(val === this.phone_status.reset || val === this.phone_status.validating) {
                    this.addonClass = {}
                }
                if(val === this.phone_status.error) {
                    this.addonClass = {error: true}
                }
                if(val === this.phone_status.success) {
                    this.addonClass = {success: true}
                }
            },
        }
    }
</script>

<style scoped>

</style>